import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import Loadable from '@loadable/component';
import ReactMoment from 'react-moment';

import './recent-news.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));

export type RecentNewsType = {
  date?: string;
  photoUrl?: string;
  name: string;
  link: string;
  fillColumn?: boolean;
};

type RecentNewsProps = {
  title?: string;
  subtitle?: string;
  news: RecentNewsType[];
  maxNewsCount?: number;
};

const RecentNews: React.FC<RecentNewsProps> = ({
  title,
  subtitle,
  news,
  maxNewsCount,
}) => {
  const [formattedLinkedArticles, setFormattedLinkedArticles] = useState<
    RecentNewsType[]
  >(news);
  useEffect(() => {
    if (maxNewsCount) {
      setFormattedLinkedArticles(
        formattedLinkedArticles.slice(Math.max(news.length - maxNewsCount, 0))
      );
    }
  }, []);
  return (
    <div className="blog pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          {subtitle && <span className="sub-title">{subtitle}</span>}
          <h2>{title || 'In The News'}</h2>
        </div>

        <div className="row">
          {formattedLinkedArticles.map(
            ({ name, link, date, photoUrl, fillColumn }, i) => (
              <div
                className={classnames(
                  { 'col-lg-4 col-md-6': !fillColumn },
                  { 'col-lg-12 col-md-12': fillColumn }
                )}
                key={i}
              >
                <Pulse>
                  <div className="single-blog-post bg-fffbf5">
                    {photoUrl && (
                      <div className="post-image">
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={photoUrl} alt="hopin logo" />
                        </a>
                      </div>
                    )}

                    <div className="post-content">
                      {date && (
                        <ul className="post-meta d-flex justify-content-between align-items-center">
                          <li></li>
                          <li>
                            <i className="flaticon-calendar"></i>
                            <ReactMoment format="MMM Do YYYY">
                              {date}
                            </ReactMoment>
                          </li>
                        </ul>
                      )}
                      <h3>
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {name}
                        </a>
                      </h3>
                    </div>
                  </div>
                </Pulse>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentNews;
